import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section className="border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="关于信源、核实与更正"
            desc="如果你准备投递线索，或者对稿件的处理方式有疑问，可以先看这几条。更完整的说明在常见问题页。"
            actionHref="/faq"
            actionLabel="全部问题"
          />
        </div>
        <div className="lg:col-span-8 reveal">
          <FaqAccordion items={faqs.slice(0, 5)} defaultOpen={0} />
        </div>
      </div>
    </section>
  );
}